import React from 'react'
import { Grid } from 'semantic-ui-react'
import { useHistory } from 'react-router-dom'

import { Button } from '@labsavvyapp/ui-components'

import style from './RecoverPassword.module.css'
import { SIGN } from '../../../config/routes'
import { LabsavvyIQLogo } from '@labsavvyapp/components'

/**
 * Recover password. Step 4: Finish.
 */
const RecoverFinish = () => {
  const { push } = useHistory()

  return (
    <Grid>
      <Grid.Column>
        <div className={style.head}>
          <LabsavvyIQLogo />
        </div>
        <h3 className={style.title}>Reset password</h3>

        <p className={style.text}>Your password has been changed.</p>

        <Button className={style.loginButton} onClick={() => push(SIGN.in)}>
          Login
        </Button>
      </Grid.Column>
    </Grid>
  )
}

export default RecoverFinish
